import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {useParams} from "react-router";
import {Card, Descriptions, Divider, Space} from "antd";
import ProfileTitle from "../../../../components/ProfileTitle";
import dayjs from "dayjs";
import {useRequest} from "ahooks";
import * as api from "../../../../apis/platforms/admin/financeRefund";
import {useHistory} from "react-router-dom";

export default function FinanceRefundDetail() {

    const history = useHistory()
    const {id} = useParams<any>()
    const [refundDetail, setRefundDetail] = useState<any>()

    useEffect(() => {
        if (id) {
            getRefundDetail(id)
        }
    }, [])

    const {run: getRefundDetail} = useRequest(api.getFinanceRefundDetail, {
        manual: true,
        onSuccess: (res) => {
            setRefundDetail(res.data.data)
        }
    })

    return (
        <PageHeaderLayout>
            <Card extra={
                <Space split={<Divider type="vertical"/>} style={{fontWeight: "bold"}}>
                    <a onClick={() => history.goBack()}>返回</a>
                </Space>
            }>
                {refundDetail && (
                    <Descriptions size={'middle'} bordered title="退款信息" column={3}>
                        <Descriptions.Item label="退款编号">{refundDetail.refundNo}</Descriptions.Item>
                        <Descriptions.Item label="客户">{refundDetail.dealerName}</Descriptions.Item>
                        <Descriptions.Item label="退款信息">{refundDetail.refundDesc}</Descriptions.Item>
                        <Descriptions.Item label="退款金额">{refundDetail.refundAmount}</Descriptions.Item>
                        <Descriptions.Item label="已核销金额">
                            {refundDetail.writeOffAmount}
                        </Descriptions.Item>
                        <Descriptions.Item label="未核销金额">
                            {refundDetail.refundAmount - refundDetail.writeOffAmount}
                        </Descriptions.Item>
                        <Descriptions.Item label="银行流水号">{refundDetail.bankSn}</Descriptions.Item>
                        <Descriptions.Item label="收款银行">{refundDetail.receivingBank}</Descriptions.Item>
                        <Descriptions.Item label="收款帐户">{refundDetail.receivingBankAccount}</Descriptions.Item>
                        <Descriptions.Item label="币种">{refundDetail.currency}</Descriptions.Item>
                        <Descriptions.Item label="汇率">{refundDetail.exchangeRate}</Descriptions.Item>
                        <Descriptions.Item label="金额（CNY）">{refundDetail.refundAmountCny}</Descriptions.Item>
                        <Descriptions.Item label="单据类型">
                            {refundDetail.refundType === 0 ? '货款' : '退货单款'}
                        </Descriptions.Item>
                        <Descriptions.Item label="核销状态" span={2}>
                            {refundDetail.writeOffAmount === 0 ? '未核销' : refundDetail.refundAmount > refundDetail.writeOffAmount ? '部分核销' : '已核销'}
                        </Descriptions.Item>
                        <Descriptions.Item label="退款说明" span={3}>{refundDetail.paymentDesc}</Descriptions.Item>
                    </Descriptions>
                )}
                <div style={{marginTop: 20, marginBottom: 20}}>
                    <ProfileTitle>核销列表</ProfileTitle>
                    <table
                        style={{
                            width: '100%',
                            textAlign: "center",
                            borderCollapse: 'collapse',
                            borderColor: 'rgba(5, 5, 5, 0.06)'
                        }}
                        border={1}
                        cellSpacing={0} cellPadding={0}>
                        <thead>
                        <tr style={{backgroundColor: 'rgba(0, 0, 0, 0.02)', color: 'rgba(0, 0, 0, 0.65)', height: 40}}>
                            <td width={'20%'}>核销单号</td>
                            <td width={'20%'}>核销日期</td>
                            <td width={'20%'}>核销金额</td>
                            <td width={'20%'}>状态</td>
                            <td width={'20%'}>操作</td>
                        </tr>
                        </thead>
                        <tbody>
                        {refundDetail && refundDetail.writeOffs.map((item: any) => {
                            return (
                                <tr style={{height: 40}}>
                                    <td>{item.writeOffNo}</td>
                                    <td>{dayjs(item.writeOffDate).format('ll')}</td>
                                    <td>{item.writeOffItemAmount}</td>
                                    <td>{item.status === 0 ? '未审核' : '已审核'}</td>
                                    <td><a onClick={() => history.push(`/finance/writeOff/detail/${item.id}`)}>详情</a></td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </Card>
        </PageHeaderLayout>
    )
}